import arrayClosestMatch from './arrayClosestMatch';
/**
 * Select the closest match in a select box
 * @param {number} number The value we want to set it to
 * @param {Element} Element The select box to update
 */
export default function(num, element) {
    if (element.options.length == 0) {
        return;
    }
    // Convert the options into an array of values
    let options = [];
    for (let index = 0, len = element.options.length; index < len; index++) {
        options.push(element.options[index].value);
    }
    // Find the closest match in those values
    let closest = arrayClosestMatch(num, options);
    // Then select the index associated with the closest value on the select element
    element.selectedIndex = options.indexOf(closest);
    return closest;
}


// WEBPACK FOOTER //
// ./resources/assets/js/modules/closestSelectValue.js